import backgroundImg from "@assets/lol-hero-background.webp";
import AbsoluteContainer from "@core-components/container/AbsoluteContainer";
import { Stack } from "@mantine/core";

export interface IBackgroundImageProps {
  children?: React.ReactNode;
  background?: string;
  classnames?: {
    stack?: string;
  };
}

const SSBackgroundImage: React.FC<IBackgroundImageProps> = ({
  children,
  background = backgroundImg,
  classnames,
}) => (
  <>
    <AbsoluteContainer>
      <Stack
        className={`dark-gradient-image-[var(--image-url)] w-full bg-cover bg-top bg-no-repeat ${classnames?.stack}`}
        style={
          {
            "--image-url": `url(${background})`,
            height: "44rem",
          } as React.CSSProperties
        }
      />
    </AbsoluteContainer>
    <div className="relative">{children}</div>
  </>
);

export default SSBackgroundImage;
